<template>
<div class="userInfoPage">
        <div class="userInfo">
            <div class="userInfo-header">
                <div class="title">
                    <h3>身份信息</h3>
                </div>

                <div class="userInfo-list">
                    <ul class="titleInfo clear">
                        <li class="list-name">姓名</li>
                        <li class="list-studentId">学工号</li>

                    </ul>
                    <ul class="listInfo clear" v-for="(item,index) in userInfo" :key="index">
                        <li class="list-name">{{item.person_name | reSet}}</li>
                        <li class="list-studentId">{{item.person_sid | reSet}}</li>

                    </ul>
                </div>
            </div>
            <div class="userInfo-container">
                <div class="list-tips clear">
                    <span>注意！请仔细确认以上信息，如果数据错误请反馈信息到信息办</span>
                </div>
                <div class="userInfo-footer">
                    <el-button type="primary" @click="submitInfo()" :class="{submitActive:submitStatus}">确  认<span v-show="submitStatus">({{submitTime}})</span></el-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
// import RegForm from './regForm'
import {checkCode} from '../../../config/formCheck'
import GetCode from '../../../config/getCode'

export default {
  name: "userInfo",
  data() {
    return {
      submitStatus:true,
      submitTime:5,
      phoneNo:"",
      xgh:[],
      userInfo:{
      },
      nowInfo: {
      },
      historyInfo: [
      ],
    };
  },
filters: {
  reSet (value) {
    if (!value) {return '空'}
    else{
        return value
    }
  },
    formateType:function(value){
      if(value == "0"){
          return "身份证"
      }else if(value == "1"){
          return "护照"
      }else if(value == "2"){
          return "港澳通行证"
      }else if(value == "3"){
          return "军官证"
      }else if(value == "4"){
          return "台胞证"
      }else if(value == "5"){
          return "香港永久性居民身份证"
      }else if(value == "6"){
          return "港澳台身份证件"
      }else if(value == "7"){
          return "回乡证"
      }else if(value == "9"){
          return "其他"
      }else if(value !=""){
           return value
      }else{
            return "空"
      }
  }
},
    created: function () {
        const self = this
        const userInfo = JSON.parse(sessionStorage.getItem("officeEmail_userInfo"))
        const phoneNo = sessionStorage.getItem("officeEmail_phoneNo")
        const token = sessionStorage.getItem('officalEmail_token')
        self.userInfo = userInfo;
        //self.xgh = userInfo.sids.split(",")
        self.phoneNo = phoneNo;
        if(self.submitStatus){
            self.submitTime = 5;
            self.timeDown ();
        }
  },

  methods:{
 //倒计时效果
    timeDown () {
        if(this.submitTime > 1) {
            this.submitTime--;
            setTimeout(this.timeDown, 1000);
        }else{
            this.submitStatus = false;
            }
    },
      //提交信息
      submitInfo(){
        if(this.submitStatus){
            return false
        }
        this.$router.push({ name: 'RegOfficialEmail'})
      }

  },
};
</script>


<style scoped>
.userInfoPage{
    width: 100%;
    height: 100vh;
    position: relative;
}
.userInfo {
  min-height: 550px;
  position: absolute;
  left: 50%;
  top:50%;
  margin-left: -485px;
  margin-top: -275px;
  width: 970px;
  background: #fff;
  border-radius: 10px 10px 0 0;
  /* box-shadow: -60px 0 100px -70px #027AEA; */
    -webkit-box-shadow:0 0 30px #027AEA;

  -moz-box-shadow:0 0 30px #027AEA;

  box-shadow:0 0 30px #027AEA;
}
.userInfo-header {
  width: 100%;
  padding-bottom: 40px;
  background: #198bfd;
  border-radius: 10px 10px 0 0;
  margin: 0;
}
.userInfo-header .title>h3{
    font-size: 26px;
    color: #fff;
    padding:30px 55px;
}
.userInfo-container .title>h3{
    font-size: 26px;
    color: #5a656c;
    padding:34px 0 30px 60px;
}
.userInfo-header .userInfo-list .titleInfo{
    font-size: 20px;
    color: #fff;
    text-align: center;
}
.userInfo-header .userInfo-list .listInfo{
    font-size: 24px;
    color: #fff;
    margin-top: 23px;
    text-align: center;
}
.list-name{
    width: 220px;
}
.list-studentId{
    width: 202px;
}
.list-IdCard{
    width: 325px;
}
.list-phone{
    width: 200px;
}
.list-Identity{
    width: 240px;
}

ul > li {
  list-style-type:none;
  float: left;
  display: block;
}
.userInfo-container{
    border-radius: 10px 10px 0 0;
    background: #fff;
    margin-top: -10px;

}
.list-titleInfo{
    font-size: 18px;
    color: #5a656c;
    margin: 18px 0 20px 67px;
}
.list-listInfo{
    font-size: 16px;
    color: #5a656c;
    margin: 0 0 0 67px;
    line-height: 50px;
}
.list-tips{
    margin-top: 45px;
}
.list-tips>span{
    float: left;
    margin-left: 70px;
    font-size: 16px;
    color: #ed6b7b;
    line-height: 30px;
}
.list-tips button{
    float: right;
    margin-right: 54px;
    font-size: 14px;
    color: #fff;
    padding: 13px 23px;
}
.userInfo-footer{
    margin-top: 50px;
    text-align: center;
    padding-bottom: 41px;
}
.userInfo-footer button{
    width: 240px;
    line-height: 45px;
    padding: 0;
}


.submitActive{
    background: #ccc;
    border: #ccc;
    color: #5a656c;
    cursor: not-allowed;
}

.submitProblem{
    width: 382px;
    height: 50px;
    color: #fff;
    padding: 0;
    font-size: 18px;
}
.el-dialog__body{
    padding-bottom: 20px;
}
.dialog-footer{
    padding-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/info/UserInfo.vue